<template>
<ContentWrapper>
    <div class="content-heading">
      <div>메시지 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          마켓팅 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/marketing/messageList">메시지 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search"/>

          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">메시지 구분</label>
            </div>
            <div class="col-auto">
                <b-form-select @change="search(1)" class="custom-select custom-select-sm" 
                  :options="data.sendTypeOption.array" v-model="data.params.sendTypeCd"></b-form-select>
            </div>
          </div>

          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search(1)" />
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="goDetail(0)" >등록</b-btn>
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="7%" style="text-align:center" >메시지 구분</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('title')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('msg')">내용<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="6%" style="text-align:center" @click="localSort.sort('userCount')">대상(명)<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('regId')">등록자 ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="15%" style="text-align:center" @click="localSort.sort('regDt')">발송일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="11">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{data.sendTypeOption.getText(item.sendTypeCd)}}</td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{item.title}}</td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)"><span class="msg_ellipsis">{{item.msg}}</span></td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{item.userCount}}</td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{item.regId}}</td>
                <td class="align-middle text-center" @click="goDetail(item.msgSeq)">{{item.regDt}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>
<style scoped>
  .msg_ellipsis {
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>
<script>
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, ValueTexts, messageSendTypes} from "@/utils/Constants";
import * as messageApi from "@/api/marketing/MessageApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import swal from 'sweetalert2';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.sendTypeOption = messageSendTypes;
      _dataObject.schOptions = [
        {value:'title', text:'제목'},
        {value:'regId', text:'등록자 ID'}
      ];
      const data = reactive(_dataObject);
      data.params.sendTypeCd = '';

      const retVals = {
        isTest,
        modalLoading,
        data,
        ...methods(props, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        if (store.state.params.name == 'messageList') {
          const storedData = store.state.params.data;
          retVals.data.params = storedData;
          store.commit('setParams', {name:'', data:undefined});
        } else {
          await retVals.reset();
        }
        await retVals.search();
      });

      return retVals;
    }
}

function methods(props, data) {

  async function reset() {
    data.params.messageCd = '';
    data.params.schType = '';
    data.params.schText = '';
  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }
    
    const result = await messageApi.getMessageList(data.params, this.isTest);
    data.list = result.data;
    data.count = result.count;
    if (data.list) data.list.forEach(e => {
      if (e.msg && e.msg.length > 256) e.msg = e.msg.substr(0, 256); // for table element ugly view fix.
    })
    this.localSort.set(data.list);
  }

  // 상세
  async function goDetail(seq){
    this.$store.commit('setParams', {name:'messageList', data:data.params});
    this.$router.push({name:'messageDetail', params:{seq:seq}});
  }

  return {
    reset,
    search,
    goDetail,
  }
}
</script>